// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v5/update_phone_number.proto

/* oxlint-disable */

/** Wrapper matching the { "user": { "phone_number": "..." } } request body shape. */
export interface ApiUpdatePhoneNumberUser {
  /** The new phone number in E.164 international format without spaces. */
  readonly phoneNumber: string;
}

/** Request message for UpdatePhoneNumber (PUT /v5/user/phone_number). */
export interface ApiUpdatePhoneNumberRequest {
  /** Phone number wrapped in user object as required by the API. */
  readonly user: ApiUpdatePhoneNumberUser | null;
}

/** Response message for UpdatePhoneNumber. */
export interface ApiUpdatePhoneNumberResponse {
}

export const ApiUpdatePhoneNumberUser: MessageFns<ApiUpdatePhoneNumberUser> = {
  fromJSON(object: any): ApiUpdatePhoneNumberUser {
    return { phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : "" };
  },

  toJSON(message: ApiUpdatePhoneNumberUser): unknown {
    const obj: any = {};
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    return obj;
  },
};

export const ApiUpdatePhoneNumberRequest: MessageFns<ApiUpdatePhoneNumberRequest> = {
  fromJSON(object: any): ApiUpdatePhoneNumberRequest {
    return { user: isSet(object.user) ? ApiUpdatePhoneNumberUser.fromJSON(object.user) : null };
  },

  toJSON(message: ApiUpdatePhoneNumberRequest): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiUpdatePhoneNumberUser.toJSON(message.user);
    }
    return obj;
  },
};

export const ApiUpdatePhoneNumberResponse: MessageFns<ApiUpdatePhoneNumberResponse> = {
  fromJSON(_: any): ApiUpdatePhoneNumberResponse {
    return {};
  },

  toJSON(_: ApiUpdatePhoneNumberResponse): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
